import React from 'react';
import SubHeader from '../SubHeader';
import NotesSection from './NotesSection';
import ResponseDocumentation from './ResponseDocumentation';
import GeneralInformation from './GeneralInformation';

export default class Response extends React.Component {
  render() {
    const {response} = this.props;

    if (!response) return null;

    return (
      <React.Fragment>
        <SubHeader label='Variation Response' number='2' />
        <GeneralInformation
          status={response.status}
          submittedBy={response.submittedBy}
          submissionDate={response.submissionDate}
          approvalDate={response.approvalDate}
        />
        <NotesSection notes={response.notes} />
        <ResponseDocumentation varDocuments={response.varDocuments} id={response.id} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Response/index.jsx